// extracted by mini-css-extract-plugin
export default {"invalidDataError":"priceCircularStyle_invalidDataError__jJL5M"};